(function (Recommendations, $, undefined) {

  var bindUIActions = function () {
    $(window).on('loadRecommendations',function(){
      console.log('loading recommendations');
      nostojs(function(api) {
        api.loadRecommendations();
      });
      for(var i = 0; i < $('.nosto_element').length; i++) {
        $('.nosto_element').eq(i).find('.slick-slider').slick('setPosition')
      }
    });
  };

  Recommendations.init = function () {
    bindUIActions();
  };

}(window.Recommendations = window.Recommendations || {}, jQuery));
